import { RefObject, useEffect, useRef, useState } from "react";

export function useElementWidth<T extends HTMLElement = HTMLDivElement>(
  initialWidth: number = 200,
): [RefObject<T>, number] {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState<number>(initialWidth);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    setWidth(element.offsetWidth);

    const resizeObserver = new ResizeObserver((entries) => {
      if (entries.length > 0) {
        const { width } = entries[0].contentRect;
        setWidth(width);
      }
    });

    resizeObserver.observe(element);
    const handleResize = () => {
      setWidth(element.offsetWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return [ref, width];
}
